import { RestSlice } from 'src/redux/rest.slice';
import { GeneralNoticeTemplate, LookupType } from '@rcp/types';
import { Resource, localizationService } from 'src/services';

export const generalNoticeTemplateSlice = new RestSlice<GeneralNoticeTemplate>(
	localizationService.getLocalizedString('authoritySetting.noticesSettings.general.general'),
	`${Resource.Settings}/${LookupType.GeneralNoticeTemplate}`
);
export default generalNoticeTemplateSlice.rests.reducer;
